<template>
  <unicom-linha>
    <unicom-coluna sm="12" class="pb-4">
      <Cabecalho
        @adiciona-filtro="adicionarFiltro"
        @remove-filtro="removeFiltro"
        class="linha-embaixo"
        :listaUnimed="listaUnimed"
        :totalPrestadores="totalPrestadores"
        :loadingGrafico="loadingGrafico"
        :loading="loading"
      />
    </unicom-coluna>
    <unicom-coluna sm="12" md="12" lg="12" xl="7" style="min-height: 495px">
      <Mapa
        @adiciona-filtro="adicionarFiltro"
        @remove-filtro="removeFiltro"
        :totalPrestadoresEstado="totalPrestadores"
        :totalPrestadoresBase="totalPrestadoresBase"
        :listaEstados="listaEstados"
        :loading="loading"
        :arrayGrafico="graficoMapa"
        :loadingGrafico="loadingGrafico"
        :listaRegioes="listaRegioes"
      />
    </unicom-coluna>
    <unicom-coluna
      sm="12"
      md="12"
      lg="12"
      xl="5"
      class="container-direita mb-4"
    >
      <TipoRede
        @adiciona-filtro="adicionarFiltro"
        @remove-filtro="removeFiltro"
        :arrayGrafico="graficoTipoRede"
        :loading="loading"
        :loadingGrafico="loadingGrafico"
        class="tipo-rede"
      />
      <TipoVinculo
        @adiciona-filtro="adicionarFiltro"
        @remove-filtro="removeFiltro"
        :arrayGrafico="graficoTipoVinculo"
        :loading="loading"
        :loadingGrafico="loadingGrafico"
        class="tipo-vinculo"
      />
    </unicom-coluna>
    <unicom-coluna sm="12" class="linha-emcima">
      <TipoPrestador
        @adiciona-filtro="adicionarFiltro"
        @remove-filtro="removeFiltro"
        :arrayGrafico="graficoTipoPrestador"
        :loading="loading"
        :loadingGrafico="loadingGrafico"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Cabecalho from "./shared/componentes/Cabecalho";
import Mapa from "./shared/componentes/Mapa/Mapa";
import DashboardMixin from "../DashboardMixin";
import TipoRede from "./shared/componentes/TipoRede";
import TipoVinculo from "./shared/componentes/TipoVinculo";
import TipoPrestador from "./shared/componentes/TipoPrestador";

export default {
  mixins: [DashboardMixin],
  components: {
    Cabecalho,
    Mapa,
    TipoRede,
    TipoVinculo,
    TipoPrestador
  }
};
</script>

<style lang="scss" scoped>
.container-direita {
  @media (max-width: 1184px) {
    border-top: 1px solid #dee2e6;
    padding-top: 1.5rem;
  }

  @media (min-width: 1185px) {
    border-left: 1px solid #dee2e6;
    padding: 0;
  }

  > .tipo-rede {
    padding: 0 15px;
    border-bottom: 1px solid #dee2e6;
    position: relative;
  }

  > .tipo-vinculo {
    padding: 15px 15px 0 15px;
    position: relative;
  }
}

.linha-emcima {
  padding-top: 24px;
  border-top: 1px solid #ebebeb;
}
</style>
